import React, { useEffect, useState } from 'react';
import "../css/videogallary.css";
import axios from 'axios';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const VideoGalleryComponent = () => {
  const url = process.env.REACT_APP_BASE_URL;
  const [videosData, setVideosData] = useState([]);
  const [currentVideoIndex,setCurrentVideoIndex] = useState(0);
  const [isCarousalOpen, setIsCarousalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const imagesPerPage = 9;

  // Fetch all videos
  async function fetchAllVideos() {
    try {
      const response = await axios.get(`${url}/api/video/all`);
      setVideosData(response.data.data || []);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error fetching gallery videos:', error);
      }
    }
  }

  // Open the carousel with the selected video
  const openCarousal = (index) => {
     // Calculate absolute index
     setCurrentVideoIndex(index);
    setIsCarousalOpen(true);
  };

  // Navigate to the previous video
  const goToPreviousImage = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? videosData.length - 1 : prevIndex - 1
    );
  };

  // Navigate to the next video
  const goToNextImage = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === videosData.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Close the carousel
  const closeCarousal = () => {
    setIsCarousalOpen(false);
  };

  useEffect(() => {
    fetchAllVideos();
  }, []);

  // Calculate images for the current page
  const startIndex = currentPage * imagesPerPage;
  const currentImages = videosData.slice(startIndex, startIndex + imagesPerPage);

  // Handle page navigation
  const goToNextPage = () => {
    if (startIndex + imagesPerPage < videosData.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <div className="gallery-container">
      {/* Carousel */}
      {isCarousalOpen && videosData[currentVideoIndex] && (
        <div className="gallery-carousal">
          <FaChevronLeft
            className="carousel-icon left-icon"
            onClick={goToPreviousImage}
          />
          <iframe
            src={videosData[currentVideoIndex].videoUrl}
            title={videosData[currentVideoIndex].title || "Video"}
            frame border="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
          <FaChevronRight
            className="carousel-icon right-icon"
            onClick={goToNextImage}
          />
          <span onClick={closeCarousal} className="close-icon">
            X
          </span>
        </div>
      )}

      {/* Gallery Grid */}
      <div className="gallery-images-grid">
        {currentImages.map((item, index) => (
         <div onClick={() => openCarousal(index)}
         
         style={{ position: 'relative', cursor: 'pointer' }}>
           <iframe
            key={index}
            src={item.videoUrl}
            title={item.title || "Video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{ pointerEvents: 'none' }} // Disable iframe interaction if necessary
          />
         </div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <FaChevronLeft
          className={`pagination-icon ${currentPage === 0 ? 'disabled' : ''}`}
          onClick={goToPreviousPage}
        />
        <span className="pagination-info">
          Page {currentPage + 1} of {Math.ceil(videosData.length / imagesPerPage)}
        </span>
        <FaChevronRight
          className={`pagination-icon ${
            startIndex + imagesPerPage >= videosData.length ? 'disabled' : ''
          }`}
          onClick={goToNextPage}
        />
      </div>
    </div>
  );
};

export default VideoGalleryComponent;
